module.exports = __webpack_public_path__ + "static/media/sidebar-image.d91775dd.jpg";